import moment from "moment";
import { getFullName, getAddress, getPdfMargins } from "../../util/helpers";
import { getLocalPhoneNumber, createTromFile } from "../../util/helpers";
var unflatten = require("flat").unflatten;
const groupBy = require("lodash/groupBy");

export const getStartItems = (record) => {
  let sorted = record
    ? record.recurrent_work_events.map((obj) => ({
        ...obj,
      }))
    : [];
  sorted.sort((a, b) => a.weekday - b.weekday);
  let final = [];
  sorted.forEach((item, i) => {
    const street =
      item.employee && item.employee.address.street !== undefined
        ? item.employee.address.street.trim() +
          " " +
          item.employee.address.house_number
        : "";
    const address =
      item.employee && item.employee.address.city !== undefined
        ? item.employee.address.city.trim() + ", " + street
        : street;
    let temp = {
      duration: (
        Math.round(
          ((item["charged_minutes"] || item["duration_minutes"]) / 60) * 100
        ) / 100
      ).toFixed(2),
      end_time: moment()
        .startOf("day")
        .set("minute", item.duration_minutes + item.start_time_minutes)
        .format("HH:mm"),
      start_time: moment()
        .startOf("day")
        .set("minute", item["start_time_minutes"])
        .format("HH:mm"),
      weekday: moment.weekdays(item["weekday"]),
      address: address,
      idOrPassport:
        item["employee"] && item["employee"]["foreign"]["passport_number"]
          ? item["employee"]["foreign"]["passport_number"]
          : item["employee"]
          ? item["employee"].local_id_number
          : "",
      employee_name:
        item["employee"] &&
        getFullName(item.employee.surename, item.employee.first_name),
    };
    final.push(temp);
  });

  return final;
};

export const setStartHeader = async (doc, record) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  var img = new Image();
  img.src = record.organization.avatar_url;
  var title = "הודעה על שירותי טרום סיעוד";
  const branchName = `${record.organization.name} - ${record.branch.name}`;
  const address = getAddress(record.branch.address);
  const branchPhone = `טלפון - ${getLocalPhoneNumber(
    record.branch.phone_number
  )}`;
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.setFontSize(12);
  doc.text(branchName, hLoc, 20, {
    align: "right",
  });
  doc.setFontSize(10);
  // Create a promise that resolves when the image is loaded
  const imageLoadPromise = new Promise((resolve) => {
    img.onload = () => {
      resolve();
    };
  });

  // Wait for the image to load
  await imageLoadPromise;
  doc.addImage(img, "png", margins, 15, (15 / img.height) * img.width, 15);

  doc.text(address, hLoc, 26, {
    align: "right",
  });
  doc.text(branchPhone, hLoc, 31, {
    align: "right",
  });
  doc.text(
    `${moment().format("DD/MM/YYYY").split("").reverse().join("")}`,
    margins,
    40,
    {
      align: "left",
    }
  );
  doc.setFontSize(18);

  doc.text(title, hLoc, 40, {
    align: "right",
  });
};

export const setStartTopContent = (doc, record) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  const planTitle = "פירוט התכנית השבועית";
  const getphone = (val) => {
    const phone = val
      ? getLocalPhoneNumber(val).split("").reverse().join("")
      : "";
    return phone;
  };
  const phone = `${getphone(
    record?.patient?.contact_info?.mobile_number
  )} ${getphone(record?.patient?.contact_info?.phone_number)}`;

  const patientContent = [
    {
      title: "שם מלא",
      value: getFullName(record.patient.surename, record.patient.first_name),
    },
    {
      title: "תעודת זהות",
      value: record.patient.local_id_number
        .padStart(9, "0")
        .split("")
        .reverse()
        .join(""),
    },
    {
      title: "כתובת",
      value: getAddress(record.patient.address),
    },
    {
      title: "מספר טלפון",
      value: phone,
    },
  ];
  const bottomLoc = setContent(
    doc,
    margins,
    hLoc,
    50,
    "פרטי המטופל",
    patientContent
  );
  const relativeContent = record.patient.mainContact && [
    {
      title: "שם מלא",
      value: record.patient.mainContact
        ? record.patient.mainContact["first_name"] +
          " " +
          record.patient.mainContact["last_name"]
        : "",
    },
    {
      title: "קרבה",
      value: record.patient.contactType,
    },
    {
      title: "מספר טלפון",
      value:
        record.patient.mainContact.mobile_number !== ""
          ? getLocalPhoneNumber(record.patient.mainContact.mobile_number)
              .split("")
              .reverse()
              .join("")
          : getLocalPhoneNumber(record.patient.mainContact.phone_number)
              .split("")
              .reverse()
              .join(""),
    },
  ];
  let serviceLoc = bottomLoc + 25;
  if (record.patient.mainContact) {
    const relativeLoc = setContent(
      doc,
      margins,
      hLoc,
      bottomLoc,
      "איש קשר",
      relativeContent
    );
    const loc = setServiceDetails(doc, margins, hLoc, record, relativeLoc);
    serviceLoc = loc;
  } else {
    const loc = setServiceDetails(doc, margins, hLoc, record, bottomLoc);
    serviceLoc = loc;
  }
  doc.setFontSize(14);

  if (record.hasPlan) {
    doc.text(planTitle, hLoc, serviceLoc, {
      align: "right",
    });
  }

  doc.setTextColor(40);
  return serviceLoc + 4;
};

export const setStartBottomContent = (
  doc,
  record,
  setHeader,
  headerRecord,
  intl
) => {
  let finalY = doc.lastAutoTable.finalY;
  if (doc.internal.pageSize.height - finalY < 40) {
    doc.addPage();
    setHeader(doc, headerRecord);
    finalY = 40;
  }
  var hLoc = doc.internal.pageSize.getWidth() - 15;
  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  const margins = getPdfMargins(doc);
  let proffessionalContent = [];
  if (record.employeeName) {
    proffessionalContent.push({
      title: "שם העובד המקצועי",
      value: record.employeeName,
    });
  }
  if (record.employeeRole) {
    proffessionalContent.push({
      title: "תפקיד",
      value: intl.formatMessage({
        id: `app.dataSelect.professional_role_id.${record.employeeRole}`,
      }),
    });
  }

  if (finalY) {
    setContent(
      doc,
      margins,
      hLoc,
      finalY + 10,
      "פרטי העובד/ת המקצועי/ת",
      proffessionalContent
    );
  }
};

const setContent = (doc, margins, hLoc, marginTop, title, content) => {
  let height = 20;
  if (content && content.length > 0) {
    doc.setFontSize(13);
    doc.text(title, hLoc - 2, marginTop + 2, {
      align: "right",
    });
    content.forEach((item, i) => {
      doc.setFontSize(11);
      doc.text(item.title, hLoc - 2 - i * 44, marginTop + 8, {
        align: "right",
      });
      doc.setFontSize(10);
      var splitValue = doc.splitTextToSize(item.value, 40);
      if (splitValue[1]) {
        height = 24;
        const isHebrew = (text) => {
          return text.search(/[\u0590-\u05FF]/) >= 0;
        };
        const first = isHebrew(splitValue[0]) ? 0 : 1;
        const last = isHebrew(splitValue[0]) ? 1 : 0;
        doc.text(splitValue[first], hLoc - 2 - i * 44, marginTop + 13, {
          align: "right",
        });

        doc.text(splitValue[last], hLoc - 2 - i * 44, marginTop + 17, {
          align: "right",
        });
      } else {
        doc.text(splitValue[0], hLoc - 2 - i * 44, marginTop + 13, {
          align: "right",
        });
      }
    });

    doc.setLineWidth(0.5);
    doc.setDrawColor(40);
    doc.rect(
      margins,
      marginTop - 4,
      doc.internal.pageSize.getWidth() - margins * 2,
      height
    );
  }
  return marginTop + height + 2;
};

const setServiceDetails = (doc, margins, hLoc, record, marginTop) => {
  const serviceText = "מהות הטיפול:";
  const startText = "הנ״ל החל/ה לקבל מאיתנו שרות טרום סיעוד בבית החל מתאריך:";
  const capacityText = "היקף השעות:";
  const initiativeText = "על פי יוזמה של:";
  const providerText = "נותן שירות";

  doc.text(startText, hLoc, marginTop, {
    align: "right",
  });
  doc.text(
    `${moment(record.effective_from)
      .format("DD/MM/YYYY")
      .split("")
      .reverse()
      .join("")}`,
    hLoc - 102,
    marginTop,
    {
      align: "right",
    }
  );
  doc.text(capacityText, hLoc - 127, marginTop, {
    align: "right",
  });
  doc.text(
    `${Math.round(record.required_weekly_minutes / 60)
      .toFixed(1)
      .split("")
      .reverse()
      .join("")}`,
    hLoc - 150,
    marginTop,
    {
      align: "right",
    }
  );
  doc.text(`${initiativeText} ${providerText}`, hLoc, marginTop + 6, {
    align: "right",
  });
  if (record.serviceType) {
    doc.text(`${serviceText} ${record.serviceType}`, hLoc - 80, marginTop + 6, {
      align: "right",
    });
  }
  return marginTop + 15;
};

export const getReportedItems = (record, items) => {
  const grouped = groupBy(items, (dt) => moment(dt.date).week());
  let final = [];
  Object.keys(grouped).map((key, i) => {
    const sum =
      Math.round(
        (grouped[key].reduce(
          (n, { duration_minutes }) => n + duration_minutes,
          0
        ) /
          60) *
          100
      ) / 100;

    const endOfWeek = moment(grouped[key][0].date).endOf("week");
    const end =
      moment(record.effective_to) < endOfWeek
        ? moment(record.effective_to).format("DD/MM/YYYY")
        : moment(endOfWeek).format("DD/MM/YYYY");
    const startOfWeek = moment(grouped[key][0].date).startOf("week");
    const startOfOrder = moment(record.effective_from).startOf("day");
    const temp = {
      names: grouped[key]
        .map((e) => getFullName(e.employee.surename, e.employee.first_name))
        .filter((v, i, a) => a.indexOf(v) === i)
        .join(", "),
      sum: sum,
      end: end,
      start:
        startOfWeek < startOfOrder
          ? startOfOrder.format("DD/MM/YYYY")
          : startOfWeek.format("DD/MM/YYYY"),
      index: i + 1,
    };
    return final.push(temp);
  });

  let finalItems = [];

  final.forEach((item, i) => {
    let temp = {
      names: item.names,
      sum: item.sum,
      end: item.end,
      start: item.start,
      index: item.index,
    };
    finalItems.push(temp);
  });

  return finalItems;
};

export const setReportedStartHeader = async (doc, record) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  const margins = getPdfMargins(doc);
  var img = new Image();
  img.src = record.organization.avatar_url;
  var title = "הודעה על נספח ב' לטרום סיעוד";
  const branchName = `${record.organization.name} - ${record.branch.name}`;
  const address = getAddress(record.branch.address);
  const branchPhone = `טלפון - ${getLocalPhoneNumber(
    record.branch.phone_number
  )}`;
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  doc.setFontSize(12);
  doc.text(branchName, hLoc, 20, {
    align: "right",
  });
  doc.setFontSize(10);

  // Create a promise that resolves when the image is loaded
  const imageLoadPromise = new Promise((resolve) => {
    img.onload = () => {
      resolve();
    };
  });

  // Wait for the image to load
  await imageLoadPromise;

  doc.addImage(img, "png", margins, 15, (15 / img.height) * img.width, 15);

  doc.text(address, hLoc, 26, {
    align: "right",
  });
  doc.text(branchPhone, hLoc, 31, {
    align: "right",
  });
  doc.text(
    `${moment().format("DD/MM/YYYY").split("").reverse().join("")}`,
    margins,
    40,
    {
      align: "left",
    }
  );
  doc.setFontSize(18);

  doc.text(title, hLoc, 40, {
    align: "right",
  });
};

export const setReportedStartTopContent = (doc, record) => {
  doc.setFontSize(16);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  const margins = getPdfMargins(doc);
  var hLoc = doc.internal.pageSize.getWidth() - margins;
  const planTitle = "שעות טרום שניתנו";
  const getphone = (val) => {
    const phone = val
      ? getLocalPhoneNumber(val).split("").reverse().join("")
      : "";
    return phone;
  };
  const phone = `${getphone(
    record?.patient?.contact_info?.mobile_number
  )} ${getphone(record?.patient?.contact_info?.phone_number)}`;

  const patientContent = [
    {
      title: "שם מלא",
      value: getFullName(record.patient.surename, record.patient.first_name),
    },
    {
      title: "תעודת זהות",
      value: record.patient.local_id_number
        .padStart(9, "0")
        .split("")
        .reverse()
        .join(""),
    },
    {
      title: "כתובת",
      value: getAddress(record.patient.address),
    },
    {
      title: "מספר טלפון",
      value: phone,
    },
  ];
  const bottomLoc = setContent(
    doc,
    margins,
    hLoc,
    50,
    "פרטי המטופל",
    patientContent
  );

  let serviceLoc = setServiceDetails(doc, margins, hLoc, record, bottomLoc);
  doc.setFontSize(14);
  if (record.hasSceduling) {
    doc.text(planTitle, hLoc, serviceLoc, {
      align: "right",
    });
    serviceLoc = serviceLoc + 3;
  }
  doc.setTextColor(40);
  return serviceLoc;
};

export const setReportedStartBottomContent = (
  doc,
  record,
  setHeader,
  headerRecord,
  intl
) => {
  let finalY = doc.lastAutoTable.finalY;
  const margins = getPdfMargins(doc);
  if (doc.internal.pageSize.height - finalY < 40) {
    doc.addPage();
    setHeader(doc, headerRecord);
    finalY = 40;
  }
  var hLoc = doc.internal.pageSize.getWidth() - 15;
  doc.setFontSize(10);
  doc.setTextColor(40);
  doc.setR2L(true);
  doc.setFont("Rubik", "normal"); // set font
  const organizationContent = [
    {
      title: "שם הארגון",
      value: record.organization.name ? record.organization.name : "",
    },
  ];

  if (finalY) {
    doc.text(headerRecord.totalText, hLoc, finalY + 4, {
      align: "right",
    });

    setContent(
      doc,
      margins,
      hLoc,
      finalY + 12,
      "פרטי הארגון",
      organizationContent
    );
  }
};

export const getStartOfTromFile = async (
  record,
  mainContact,
  mainContactType,
  employeeName,
  employeeRole,
  serviceTypeName,
  organization,
  branch,
  intl
) => {
  const items = getStartItems(record);
  const headerRecord = {
    organization,
    branch,
    patient: {
      ...unflatten(record).patient,
      mainContact: mainContact,
      contactType: mainContactType,
    },
    effective_from: record.effective_from,
    serviceType: serviceTypeName,
    required_weekly_minutes: record.required_weekly_minutes,
    hasPlan: items && items.length > 0,
  };
  const footerRecord = {
    employeeName,
    employeeRole,
  };
  let columnStyles = {
    0: { cellWidth: 23 },
    1: { cellWidth: 20 },
    2: { cellWidth: 25 },
    3: { cellWidth: 22 },
    4: { cellWidth: 38 },
    5: { cellWidth: 24 },
    6: { cellWidth: 32 },
  };
  const pdf = await createTromFile(
    intl.formatMessage({
      id: "app.prospectuses.printForecastsFileName",
    }),
    items,
    setStartHeader,
    headerRecord,
    setStartTopContent,
    setStartBottomContent,
    footerRecord,
    "paging",
    121,
    intl,
    "trom",
    {
      styles: { fontSize: 11 },
      columnStyles: columnStyles,
      // margin: { top: 121 },
    },
    "p",
    "print"
  );
  return pdf;
};

export const getReportedTromFile = async (
  record,
  schedulingItems,
  organization,
  branch,
  intl
) => {
  const reportedItems = getReportedItems(record, schedulingItems);
  const total =
    Math.round(reportedItems.reduce((n, { sum }) => n + sum, 0) * 100) / 100;
  const text = "סה״כ שעות:";
  const totalText = `${text} ${total}`;

  const headerRecord = {
    organization,
    branch,
    patient: {
      ...unflatten(record).patient,
    },
    effective_from: record.effective_from,
    required_weekly_minutes: record.required_weekly_minutes,
    hasSceduling: reportedItems && reportedItems.length > 0,
    totalText,
  };
  const footerRecord = {
    organization,
  };
  let columnStyles = {
    0: { cellWidth: 90 },
    1: { cellWidth: 15 },
    2: { cellWidth: 32 },
    3: { cellWidth: 32 },
    4: { cellWidth: 13 },
  };
  const pdf = await createTromFile(
    intl.formatMessage({
      id: "app.prospectuses.printForecastsFileName",
    }),
    reportedItems,
    setReportedStartHeader,
    headerRecord,
    setReportedStartTopContent,
    setReportedStartBottomContent,
    footerRecord,
    "paging",
    94,
    intl,
    "trom",
    {
      styles: { fontSize: 11 },
      columnStyles: columnStyles,
      margin: { top: 43 },
    },
    "p",
    "print"
  );
  return pdf;
};
